import { render, staticRenderFns } from "./MMemoryCookieAlerts.vue?vue&type=template&id=6b81d1d6&scoped=true&lang=pug&"
import script from "./MMemoryCookieAlerts.vue?vue&type=script&lang=js&"
export * from "./MMemoryCookieAlerts.vue?vue&type=script&lang=js&"
import style0 from "./MMemoryCookieAlerts.vue?vue&type=style&index=0&id=6b81d1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b81d1d6",
  null
  
)

export default component.exports